import {testIdProps} from '@github-ui/test-id-props'
import {Token, type TokenProps} from '@primer/react'
import {clsx} from 'clsx'
import {forwardRef} from 'react'

import type {LinkedPullRequest} from '../../api/common-contracts'
import {ItemType} from '../../api/memex-items/item-type'
import {tokenIconSize} from '../common/avatars-token'
import {ItemState} from '../item-state'
import styles from './linked-pr-token.module.css'

export interface LinkedPullRequestTokenProps
  extends Omit<TokenProps, 'as' | 'href' | 'leadingVisual' | 'text' | 'ref' | 'sx'> {
  linkedPullRequest: LinkedPullRequest
  isDecorative?: boolean
}

export const LinkedPullRequestToken = forwardRef<HTMLAnchorElement, LinkedPullRequestTokenProps>(
  ({linkedPullRequest, className, isDecorative, ...tokenProps}, ref) => {
    return isDecorative ? (
      <Token
        ref={ref}
        as="span"
        data-hovercard-url={`${linkedPullRequest.url}/hovercard`}
        leadingVisual={() => (
          <ItemState
            isDraft={linkedPullRequest.isDraft}
            isBlocked={false}
            state={linkedPullRequest.state}
            type={ItemType.PullRequest}
            size={tokenIconSize(tokenProps.size)}
          />
        )}
        text={`#${linkedPullRequest.number}`}
        className={clsx(styles.LinkedPullRequestToken, className)}
        {...testIdProps(`linked-pr-token-decorative`)}
        {...tokenProps}
      />
    ) : (
      <Token
        ref={ref}
        as="a"
        href={linkedPullRequest.url}
        target="_blank"
        rel="noreferrer"
        data-hovercard-url={`${linkedPullRequest.url}/hovercard`}
        leadingVisual={() => (
          <ItemState
            isDraft={linkedPullRequest.isDraft}
            isBlocked={false}
            state={linkedPullRequest.state}
            type={ItemType.PullRequest}
            size={tokenIconSize(tokenProps.size)}
          />
        )}
        text={`#${linkedPullRequest.number}`}
        className={clsx(styles.LinkedPullRequestToken, className)}
        {...testIdProps(`linked-pr-token`)}
        {...tokenProps}
      />
    )
  },
)
LinkedPullRequestToken.displayName = 'LinkedPullRequestToken'
